import styled from '@emotion/styled'
import { FC, ReactNode } from 'react'
import colors from '../colors'
import { smallTablet } from './responsive'

/** The height of every bar at the top of a phone screen. */
export const MOBILE_NAV_BAR_HEIGHT = 52

const Bar = styled.header`
	align-items: center;
	background-color: ${colors.indigoBlue};
	color: ${colors.white};
	display: flex;
	flex-shrink: 0;
	height: ${MOBILE_NAV_BAR_HEIGHT}px;
	justify-content: center;
	padding: 0 52px;
	position: relative;
	width: 100%;

	${smallTablet} {
		display: none;
	}
`

// The back control and the action: 40 px to tap, a 20 px icon 18 px in
// from the edge.
const Side = styled.div`
	align-items: center;
	display: flex;
	height: 100%;
	position: absolute;
	top: 0;

	> a,
	> button {
		align-items: center;
		background: none;
		border: 0;
		color: inherit;
		cursor: pointer;
		display: flex;
		height: 40px;
		justify-content: center;
		padding: 0;
		width: 40px;
	}

	svg {
		height: 20px;
		width: 20px;
	}
`

const Start = styled(Side)`
	left: 8px;
`

const End = styled(Side)`
	right: 8px;
`

const Title = styled.h1`
	font-family: Ubuntu;
	font-size: 16px;
	font-weight: normal;
	line-height: 20px;
	margin: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

type Props = {
	title: ReactNode
	/** The back link or button, holding its arrow. */
	back?: ReactNode
	/** One action at the end, such as sending a report. */
	action?: ReactNode
	/** A training's organization colors; indigoBlue and white otherwise. */
	backgroundColor?: string
	fontColor?: string
	className?: string
}

/**
 * The bar at the top of a phone screen: back, the screen's name and an
 * action. Phones only - it is hidden from 768 px up.
 */
export const MobileNavBar: FC<Props> = ({
	title,
	back,
	action,
	backgroundColor,
	fontColor,
	className,
}) => (
	<Bar className={className} style={{ backgroundColor, color: fontColor }}>
		{back ? <Start>{back}</Start> : null}
		<Title>{title}</Title>
		{action ? <End>{action}</End> : null}
	</Bar>
)
